export const ROLE_INFO = {
  admin: {
    label: "Admin",
    color: "!text-[#8B87C8] !border-[#4f4c90]/40 bg-[#4f4c90]/10",
    perms: [
      "Everything an Agent can do",
      "Invite, remove, and manage users",
      "Change workspace Settings",
      "Configure taxonomy & auto-assign rules",
      "Purge tickets",
      "Configure the Microsoft 365 mailbox",
    ],
  },
  agent: {
    label: "Agent",
    color: "!text-[#39A36E] !border-[#39A36E]/40 bg-[#39A36E]/10",
    perms: [
      "View and reply to all tickets",
      "Assign, reprioritise, and close tickets",
      "Add internal notes",
      "Write knowledge base articles",
      "Cannot edit workspace Settings",
      "Cannot manage users",
    ],
  },
  requester: {
    label: "Requester",
    color: "!text-[#F59E0B] !border-[#F59E0B]/40 bg-[#F59E0B]/10",
    perms: [
      "Submit tickets via the /portal page",
      "View & reply on their own tickets",
      "Cannot see other requesters' tickets",
      "Cannot access agent dashboards",
    ],
  },
};

export function PermissionsMatrix() {
  return (
    <div className="mt-4 rounded-md border border-slate-200 bg-[#F7F9FB] p-3">
      <div className="text-[11px] uppercase text-slate-500 tracking-wider font-mono mb-2">
        Who can do what
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {Object.entries(ROLE_INFO).map(([role, info]) => (
          <div key={role} className="rounded p-2 bg-slate-50 border border-slate-100">
            <div className={`chip w-fit ${info.color} mb-2`}>{info.label}</div>
            <ul className="space-y-1">
              {info.perms.map((p) => (
                <li key={p} className="text-[11px] text-slate-700 flex items-start gap-1.5">
                  <span className="text-slate-400 mt-0.5">•</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
